'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { useMobileSearch } from '@eliadmin/core/src/components/header/mobile-search';
import { useRef } from 'react';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
};

export function SearchButton(props: SearchButtonProps) {
  const { className, ...buttonProps } = props;
  const sharedOpen = useMobileSearch((s) => s.isOpen);
  const toggle = useMobileSearch((s) => s.toggle);
  const sharedOpenRef = useRef(sharedOpen);
  sharedOpenRef.current = sharedOpen;
  const notifyOpen = (next: boolean) => {
    if (sharedOpenRef.current === next) return;
    sharedOpenRef.current = next;
    toggle();
  };
  return (
    <SearchDrawer
      onOpenChange={notifyOpen}
      trigger={
        <Button
          type="button"
          {...buttonProps}
          className={cn('text-foreground', 'ea-search-button', className?.root)}
          variant={'none'}
          size="none"
          aria-label="Search"
        >
          <FiSearch
            className={cn('h-6 w-6 sm:h-5 sm:w-5', 'ea-search-button__icon', className?.icon)}
          />
        </Button>
      }
    />
  );
}
